import { lazy } from 'react';

export const CalculationUpdate = lazy(() =>
    import('./CalculationUpdate').then((module) => ({ default: module.CalculationUpdate })),
);
